import {FormWidget} from '../models/tool/form-widget';

export const formWidgets: FormWidget[] = [
  new FormWidget().deserialize({
    slug: '89de9384',
    name: 'White-Label Multistep Form',
  }),
  new FormWidget().deserialize({
    slug: '5c1d0f60',
    name: 'White-Label Tarot Form',
  }),
  new FormWidget().deserialize({
    slug: '025ed9c7',
    name: 'White-Label Horoscope Form',
    folderSet: 1,
    authorizedFolderSet: 19,
    gridFormat: 4,
    authorizedGridFormat: [4, 3, 2]
  }),
  new FormWidget().deserialize({
    slug: '5806be69',
    name: 'White-Label OnePage Form',
  }),
  new FormWidget().deserialize({
    slug: '625ff3d1',
    name: 'White-Label OnePage Legacy',
  }),
  new FormWidget().deserialize({
    slug: 'a793cb17',
    name: 'White-Label Horoscope LP like',
  }),
];
